import React from "react";
import { Box, Typography, Button, IconButton } from "@mui/material";
import UploadFileIcon from "@mui/icons-material/UploadFile";
import DeleteIcon from "@mui/icons-material/Delete";

const PrimaryImageUploader = ({ image, onUpload, onRemove, fileInputRef }) => {
  return (
    <Box sx={{ width: "100%", p: 2 }}>
      <Typography variant="body2" fontWeight="bold" gutterBottom>
        Main Style (Primary Image)
      </Typography>

      {image ? (
        <Box
          display="flex"
          alignItems="center"
          gap={2}
          mb={2}
          position="relative">
          <img
            src={image}
            alt="Primary"
            style={{
              width: 100,
              height: 100,
              objectFit: "cover",
              borderRadius: 4,
              border: "2px solid #1976d2",
            }}
          />
          <Typography variant="caption" color="primary" fontWeight="bold">
            Main Style (Primary)
          </Typography>
          <IconButton
            size="small"
            onClick={onRemove}
            sx={{ position: "absolute", top: -6, right: -6 }}>
            <DeleteIcon fontSize="small" />
          </IconButton>
        </Box>
      ) : (
        <Typography variant="body2" color="text.secondary" mb={1}>
          No primary image uploaded yet.
        </Typography>
      )}

      <Button
        startIcon={<UploadFileIcon />}
        onClick={() => fileInputRef.current?.click()}>
        Upload Primary Image
      </Button>

      <input
        type="file"
        accept="image/*"
        ref={fileInputRef}
        onChange={onUpload}
        style={{ display: "none" }}
      />
    </Box>
  );
};

export default PrimaryImageUploader;
